export default {
  columns: 'Stĺpce',
  hasTotal: 'Súčet',
  addColumn: 'Pridať stĺpec',
  unknownAttribute: 'Odstránený atribút',
};
